<template>
  <section
    class="top-destinations horizontal-slider"
    :class="{ desktop: $isDesktop }"
  >
    <div class="destinations-list">
      <a
        v-for="destination of popularSearches"
        :key="destination.hierarchy + lang"
        :href="destination.hierarchy"
      >
        <span class="location">{{ destination.name }}</span>
        <span
          v-if="lang !== 'en-gb' && destination.additionalDisplayName"
          class="subtext"
          >{{ destination.additionalDisplayName }}</span
        >
      </a>
    </div>
  </section>
</template>

<script setup lang="ts">
import { useRoute, useState } from 'nuxt/app'
import { computed, onServerPrefetch, shallowRef } from 'vue'

const route = useRoute()
const lang = computed(() => (route.params.lang as string) || 'en-gb')

const popularSearches = useState('popularSearches', () =>
  shallowRef({ deep: 'not reactive' }),
)

onServerPrefetch(async () => {
  const results = await $fetch('/api/glampingPopularSearch')
  popularSearches.value = results.popularSearches
})
</script>

<style scoped>
.top-destinations {
  margin: auto -1.4em;
  display: block;
  overflow-x: auto;
  overflow-y: visible;
  scroll-snap-type: x mandatory;
}

@supports selector(::-webkit-scrollbar) {
  .top-destinations:not(.desktop)::-webkit-scrollbar {
    display: none;
  }
}

.destinations-list {
  display: flex;
  flex-wrap: nowrap;
  min-width: max-content;
  padding: 0.5em 0.4em 1em 1.4em;
}

a {
  align-items: center;
  background: #185ba1;
  border-radius: 6em;
  color: white;
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  font-weight: bold;
  justify-content: center;
  line-height: 1.15;
  margin: 0.5em 1em 0.5em 0;
  min-height: 2.25em;
  padding: 0.3em 1.5em;
  text-decoration: none;
  max-width: 110vw;
}

.location {
  font-size: var(--body);
}

.subtext {
  font-size: var(--small);
  font-weight: normal;
  color: #c3d4e5;
}

.destination {
  align-items: center;
  border-radius: 0.3em;
  color: white;
  display: flex;
  line-height: 1;
  margin-bottom: 0.2em;
  min-height: 6em;
  overflow: hidden;
  position: relative;
  text-decoration: none;
  text-shadow: 0.05em 0.05em 0.3em rgba(0, 0, 0, 0.5);
  width: 100%;
}

.desktop .destinations-list {
  padding: 0;
}

.desktop .destinations-list a {
  font-size: 1.3em;
  min-width: 7em;
  max-width: 21em;
  transition: box-shadow 0.15s ease-out;
  scroll-snap-align: start;
  scroll-snap-stop: normal;
}

.desktop .destinations-list a span {
  transition: transform 0.2s ease-out;
}

.desktop .destinations-list a:hover,
.desktop .destinations-list a:focus-visible {
  box-shadow: 0 0 0 7px var(--focus-ring-colour);
  outline: none;
}

.desktop .destinations-list a:hover span,
.desktop .destinations-list a:focus-visible span {
  transform: scale(1.15);
}

@supports (scrollbar-width: none) {
  .top-destinations {
    scrollbar-width: none;
  }

  .desktop .top-destinations {
    scrollbar-width: thin;
  }
}
</style>
